exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Mixins\n */\n.uk-float-right .uk-button {\n  font-size: 15px; }\n\n.guides-list th {\n  font-size: 15px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/guides/guides.component.scss
// module id = ../../../../../src-admin/app/components/guides/guides.component.scss
// module chunks = main